<template>
  <div class="btn-wrap" @click="$emit('tap')">
    <div class="animation-btn" />
    <div class="btn-label">{{ label }}</div>
  </div>
</template>

<script>
  export default {
    name: 'animation-btn',

    props: {
      label: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn-wrap {
    position: relative;
    width: 295px;
    height: 44px;
  }

  .btn-label {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
  }

  .animation-btn {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #ff6e08;
    box-shadow: 0px 3px 8px 0px rgba(255, 110, 8, 0.16);
    border-radius: 22px;

    animation-name: btnScale; // 动画名称
    animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
    animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
    animation-delay: 0s; // 动画延迟时间
    animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
    animation-duration: 1.2s; // 动画完成时间
  }

  @keyframes btnScale {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(0.95);
    }
    50% {
      transform: scale(0.9);
    }
    75% {
      transform: scale(0.95);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
